import axios from "axios";
import React, { useState, useEffect } from "react";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../../Univ.js'
function AddInsurCmpy(){
    const [insur, setInsur] = useState([]);
    const [rows, setRows] = useState([]);
    const [insurCmpyView,setInsurCmpyView] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [compData,setCompData]=useState({
        "type":'',
        "company":'',
        "status":'',
        "addedby":'',
        "ip_add":''
    });

    const handleChange = (event) => {
        setCompData({
            ...compData,
            [event.target.name]:event.target.value
        });
    }

    const formSubmit = () =>{
        const _formData = new FormData();
        _formData.append('type',compData.type_id);
        _formData.append('company',compData.company);
        _formData.append('status','1');
        _formData.append('addedby', userName);
        _formData.append('ip_add', ipAddress);
          _formData.append('location', userLocation);
        try{
            axios.post(baseUrl+'insur-cmpy/', _formData, {
                headers : {
                    'content-type': 'multiple/form-data'
                }
            })
            .then(function (response) {
               if(response.status==200 || response.status==201){
                    Swal.fire({
                        title: 'Data has been updated',
                        icon: 'success',
                        timer:5000,
                        showConfirmButton: false
                    });
               setTimeout(() => {
                  window.location.href = '/insur-cmpy/';
                }, 3000);
               }
            });
            }catch(error){
                console.log(error);
            }
        };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
      if (insurCmpyView.length > 0) {
        setRows(insurCmpyView);
      }
  }, [insurCmpyView]);
  function fetchData() {
    setIsLoading(true);
    axios.get(`${baseUrl}insur-cmpy/`)
      .then(response => {
        setInsurCmpyView(response.data);
        setIsLoading(false);
      })
      .catch(error => {
        console.log(error);
        setIsLoading(false);
      });
  }
    useEffect(() => {
        try{
            axios.get(baseUrl+'insur-type/')
            .then(function (response) {
                setInsur(response.data);
            });
        }catch(error){
            console.log(error);
        }
        },[]);
    const handleDelete = (id) => {
        Swal.fire({
            title: 'Confirm',
            text: 'Are you Sure you want to delete this',
            icon: 'info',
            confirmButtonText: 'Continue',
            showCancelButton: true
        }).then((result)=>{
            if(result.isConfirmed){
               try{
                   axios.delete(baseUrl+'delete-insur-cmpy/'+ id +'/')
                   .then(function (response) {
                      Swal.fire('success', 'Data has been Deleted');
                    });
               }catch(error){
                    Swal.fire('error', 'Data has not been deleted');
               }
            }else{
                  Swal.fire('error', 'Data has not been deleted');
            }

        })
    }
  const columns = [
    { field: 'id', headerName: 'Id', width: 70 },
    {
      field: 'type',
      headerName: 'Type',
      width: 200,
      renderCell: (params) => {
        return params.row.type?.type || '';
      },
    },
    { field: 'company', headerName: 'Company', width: 500 },
    { field: 'addedby', headerName: 'Added By', width: 120},
    { field: 'edit', headerName: 'Edit',
        renderCell: (params) => (
          <Link to={`/edit-insur-cmpy/${params.row.id}`} target="_blank" className="btn btn-warning">
            Edit
          </Link>
      ),
      width: 120 },
      { field: 'delete', headerName: 'Action',
        renderCell: (params) => (
          <button onClick={()=> handleDelete(params.row.id)} className="btn btn-danger btn-sm ms-1">
          <i className="fa-solid fa-trash-can"></i></button>
      ),
      width: 120 },

  ];

    return (
        <section className="container mt-4">
            <div className="row">

              <div className='col-md-9 col-12 mb-2'>
                <div className='card'>
                    <h4 className='card-header'>Add Insurance Company</h4>
                    <div className='card-body'>
                        <form>
                          <div className="mb-3">
                            <label htmlFor="type_id" className="form-label">Insur Type</label>
                            <select name="type_id" value={compData.type_id} onChange={handleChange} className="form-control">
                                <option>Select Insur Type</option>
                                {insur.map((type,index) => {return <option key={index} value={type.id}>{type.type}
                                </option>})}
                            </select>
                          </div>
                          <div className="mb-3">
                            <label htmlFor="company" className="form-label">Insur Company</label>
                            <input type="text" className="form-control" name="company" value={compData.company}
                            onChange={handleChange} id="company" />
                          </div>
                          <button type="button" onClick={formSubmit} className="btn btn-primary">Submit</button>
                        </form>
                    </div>
                </div>
              </div>
            </div>


        <div style={{ height: "100%", width: "100%" }}>
          <DataGrid className="mt-4"
            sx={{
              boxShadow: 4,
              border: 4,
              borderColor: 'primary.light',
              '& .MuiDataGrid-cell:hover': {
                color: 'primary.main',
              },
            }}
            pageSize={28}
            rows={rows}
            columns={columns}
            components={{
                Toolbar: GridToolbar,
             }}
            autoHeight
          />
          </div>

        </section>

)
}

export default AddInsurCmpy;